import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { UsuarioService } from '@account/usuario.service';
import { EstadoPedidoMonitoreo } from '@shared/enums/EstadoPedidoMonitoreo';
import { MonitoreoConfiguracion } from '@shared/models/despacho/MonitoreoConfiguracion';
import { PedidoMonitoreo } from '@shared/models/despacho/PedidoMonitoreo';
import { MessageService } from '@shell/message.service';
import { PedidoService } from '../../pedido.service';

@Component({
  selector: 'app-screen-monitor',
  templateUrl: './screen-monitor.component.html',
  styleUrls: ['./screen-monitor.component.scss']
})
export class ScreenMonitorComponent implements OnInit, OnDestroy, AfterViewInit {

  obteniendoPedidos:boolean=false;
  pedidos: PedidoMonitoreo[];
  
  pedidosAux: PedidoMonitoreo[];
 
  @ViewChild('fullScreenContent') fullScreenContent!: ElementRef;
  elem: any; 
  isFullScreen: boolean; 

  configuracion:MonitoreoConfiguracion;
  
  EstadoPedidoMonitoreo = EstadoPedidoMonitoreo;
  fechaHoy:Date;
  seg = 70;
  segundos:number=this.seg;
  idInterval;
  idInterval2;

  constructor(
    private pedidoService: PedidoService,
    private usuarioService:UsuarioService,
    private messageService: MessageService,
    ) {}

  ngOnInit(): void {    
    this.obtenerConfiguracion();
    this.obtenerMonitorPedidos(true);
    this.countDown();    
    this.countDown2();    
  }

  ngOnDestroy() {
    if (this.idInterval) {
      clearInterval(this.idInterval);
    }
    if (this.idInterval2) {
      clearInterval(this.idInterval2);
    }
  }

  /** full screen */
  ngAfterViewInit() {
    this.goFullScreen();
  }

  fullscreenmodes(){
    this.chkScreenMode();
  }

  chkScreenMode(){
    if(document.fullscreenElement){
      //fullscreen
      this.isFullScreen = true;
    }else{
      //not in full screen
      this.isFullScreen = false;
    }
  }

  goFullScreen(): void {
    const elem = this.fullScreenContent.nativeElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { // Firefox
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { // Chrome, Safari y Opera
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { // IE/Edge
      elem.msRequestFullscreen();
    }
  }

  /** utiles */
  countDown() {
    this.idInterval = setInterval(() => {
      this.segundos--;
      if(this.segundos==0) {
        this.controlarTiempoTranscurrido();
        this.segundos=this.seg;
        /*this.obteniendoPedidos=false;
        this.spinner.hide();*/
      }
      /**
       * en un futuro agregar signal R para refrescar el monitor
       */
      if(this.segundos==10) {
        /*this.obteniendoPedidos=true;
        this.spinner.show();*/
        this.obtenerMonitorPedidos(false);
      }
    }, 1000);
  }

  countDown2() {
    this.idInterval2 = setInterval(() => {
      this.fechaHoy = new Date();
    }, 1000);
  }

  controlarTiempoTranscurrido() {
    if(this.pedidos.length>0) {
      this.pedidos.forEach( p => {
        p.minutos = this.calcularDiferenciaMinutos(new  Date(p.fechaHoraVuelo), new Date());
        p.color='#FFFFFF';
        if(p.esPrioridad && p.estado != EstadoPedidoMonitoreo.Cargado) {
          p.color=this.configuracion.colorPrioridad;
        } else {
          if(p.estado==EstadoPedidoMonitoreo.Pendiente || p.estado==EstadoPedidoMonitoreo.Asignado) {
            for(const x of this.configuracion.configuracionesTiempo.sort( (a,b) => a.minutos - b.minutos)) {
              if(p.minutos<=x.minutos) {
                p.color=x.color;
                break;
              }
            }          
          } else { 
            p.estado==EstadoPedidoMonitoreo.Precargado ? p.color=this.configuracion.colorPrecargado : p.color=this.configuracion.colorCargado
          } 
        }
      }); 
      this.pedidosAux = this.pedidos;
    }    
  }

  calcularDiferenciaMinutos(fecha1, fecha2) {
    const diferencia = (fecha1.getTime() - fecha2.getTime()) / 1000 / 60;
    //return Math.round(Math.abs(diferencia));
    return Math.round(diferencia);
  }

  getCodigoAeroplanta(){
    return this.usuarioService.getAeroplantaActual().codigoAeroplanta;
  }

  obtenerTipoEstado(tipo){
    return EstadoPedidoMonitoreo[tipo];
  }

  transformarTexto(estado:EstadoPedidoMonitoreo, texto:string) {
    // cadena = ',44502(-27981),44502(-27981),44519(8380)';
    /** Aignado 44502(-27981)     
     *  44519(8380)
    */
    if(estado===EstadoPedidoMonitoreo.Asignado || estado===EstadoPedidoMonitoreo.Precargado) {
      const textoFormateado = texto.startsWith(',') ? texto.substring(1) : texto; // quito la primera coma
      const items = textoFormateado.split(','); // armo un array por ","
      const uniqueItems = Array.from(new Set(items)); // elimino repetidos 44502
      const formattedItems = uniqueItems.map(item => item.replace(/(\d+)\(/, '$1 ('));
      const result = formattedItems.join('<br>'); // agrego una etiqueta <br> para tabular el html
      return result;
    }else{
      return texto;
    }
  }

  /** servicios */
  obtenerConfiguracion() {
    this.pedidoService.getMonitoreoConfiguracion(this.getCodigoAeroplanta())
    .subscribe( c => {
      this.configuracion=c;
      this.configuracion.configuracionesTiempo=this.configuracion.configuracionesTiempo.sort( (a,b) => a.minutos - b.minutos );
    });
  }

  async obtenerMonitorPedidos(controlar:boolean) {

    try {
      const r = await this.pedidoService.getMonitoreoPedidos(this.getCodigoAeroplanta());        
      this.pedidos = r.sort((a,b) => new Date(a.fechaHoraVuelo).getTime() - new Date(b.fechaHoraVuelo).getTime())                
      if(this.pedidos.length>0 && controlar) {
        this.pedidosAux = this.pedidos;
        this.controlarTiempoTranscurrido();
      }
    } catch (error) {      
      this.messageService.showErrorMessage("Error: " + error.message + " descripcion: " + error.descripcion);
    }    
  }
}
